import { z } from 'zod';

// HACK had to inline this instead of using the one in @varos/research-schema due to dependency issue
// these must be kept in sync until issue is resolved
export const FormInterviewMetadataSchema = z.object({
    interview_agent_name: z.string(),
    interview_agent_tone: z.array(z.string()),
    interview_goals: z.string(),
    interview_context: z.string(),
});
